import { Button, Flex, Grid, Text } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react';
import { Variants, motion } from 'framer-motion';
import React, { useRef } from 'react';
import { PdfThumbnail } from './PdfThumbnail';
import { Content } from '../data/content';
import { useRouter } from 'next/router';

export default function PdfList({ contents }: { contents: Content[] }) {
  const scrollRef = useRef(null);
  const itemMotion: Variants = {
    hidden: { opacity: 0, y: 50 },
    show: {
      transition: {
        mass: 1,
        duration: 0.6,
        type: 'tween',
      },
      opacity: [0, 0.2, 0.3, 0.5, 1],
      y: 0,
      height: '100%',
    },
  };

  return (
    <Grid>
      {contents?.map((pdf, index) => (
        <Grid.Col key={index} md={3} xs={6} sm={4} span={12}>
          <motion.div
            initial="hidden"
            whileInView="show"
            variants={itemMotion}
            viewport={{ root: scrollRef, once: true }}
          >
            <PdfCard {...pdf} />
          </motion.div>
        </Grid.Col>
      ))}
    </Grid>
  );
}

const PdfCard = ({ title, fileUrl }: Content) => {
  const router = useRouter();
  const locale = router.locale || 'pt-BR';

  return (
    <div
      className={`bg-black flex backdrop-blur-sm w-full h-full bg-opacity-40 rounded-lg overflow-hidden flex-col`}
    >
      <PdfThumbnail fileUrl={fileUrl} />

      <Flex direction="column" gap="md" p="md">
        {title[locale] && (
          <Text ta="left" weight="bold" size="md">
            {title[locale]}
          </Text>
        )}

        <div className="flex justify-between gap-md items-center mt-auto">
          <Button
            component="a"
            variant="default"
            href={fileUrl}
            download
            className="w-fit ml-auto"
            leftIcon={<IconDownload size={20} style={{ marginBottom: 3 }} />}
          >
            Download
          </Button>
        </div>
      </Flex>
    </div>
  );
};
